export const SERVICES_STORE = "SERVICES_STORE"
export const ABOUT_STORE = "ABOUT_STORE"
export const VALUES_STORE = "VALUES_STORE"
export const CONTACTS_STORE = "CONTACTS_STORE"
